<template>
    <div id="client_modal" class="absolute" v-show="showModal">
        <div class="client_modal-content relative p-20">
            <vs-button class="close_modal absolute top-0 right-0 bg-white" color="black" radius type="border" icon="close" @click="closeModal"></vs-button>
            <h2 class="font-light text-lg mb-5">EXEMPLE DE MODÈLE :</h2>
            <vs-button color="primary" type="border" icon-pack="far" icon="fa-download" class="download__button mb-8" @click="getTemplate()">Télécharger le modèle</vs-button>
            <div class="client_modal-upload">
                <ClientExcel/>
            </div>
        </div>
    </div>
</template>

<script>
import ClientExcel from './ClientExcel'
import axios from '@/axios.js'

export default {
  props: {
    showModal: Boolean
  },
  components: {
    ClientExcel
  },
  methods: {
    closeModal () {
      this.$emit('close-modal', { boolean: false })
    },
    getTemplate () {
      axios.get('/debiteurs/example/download',
        {
          responseType: 'blob'
        }
      )
        .then(response => {
          const href = URL.createObjectURL(response.data)
          const link = document.createElement('a')
          link.href = href
          link.setAttribute('download', 'invoices.xlsx')
          document.body.appendChild(link)
          link.click()

          document.body.removeChild(link)
          URL.revokeObjectURL(href)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  #client_modal {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;

    .client_modal-content {
      background-color: #fff;
      width: 80%;
      max-width: 900px;

        .close_modal {
            transform: translate(50%, -50%);
        }

        .download__button {
          padding: 10px;
        }
    }
  }
</style>
